/* @flow */

import invariant from 'invariant';
import $ from 'jquery';
import moment from 'moment';
import get from 'lodash/get';
import range from 'lodash/range';
import api from '../utils/api';
import pagseguro from './pagamento/pagseguro-maxscalla';
import getElementoPorId from '../utils/get-elemento-por-id';
import getInputPorId from '../utils/get-input-por-id';
import loadScript from '../utils/load-script';
import { type MetodoPagamento } from './pagamento/types';
import * as mascaras from '../utils/mascaras';
import applyLoading from '../utils/apply-loading';
import { setErrorOnInput, removeErrorOnInput } from '../utils/utils-formulario';
import alertas from '../alertas';

const boxSelecionarPlano = getElementoPorId('boxSelecionarPlano');
const boxConfirmarPagamento = getElementoPorId('boxConfirmarPagamento');
const acoesConfirmarPagamento = getElementoPorId('acoesConfirmarPagamento');

const btnVoltarPlano = getElementoPorId('btnVoltarPlano');
const anoVenceCartao = getElementoPorId('anoVenceCartao');

const CARTAO_UNDEFINED = 'https://hml.api.plom.com.br/img/mobile/bandeira_original_cartoes/card-online.png';

const mostrarPlanos = () => {
    boxSelecionarPlano.style.display = 'block';
    boxConfirmarPagamento.style.display = 'none';
    acoesConfirmarPagamento.style.display = 'none';
};

const setAnosDeValidade = () => {
    anoVenceCartao.innerHTML = '';
    const anoAtual = parseInt(moment().format('YYYY'), 0);
    range(anoAtual, anoAtual + 30).forEach((ano) => {
        anoVenceCartao.appendChild(
            new global.Option(ano, ano),
        );
    });
};

const setSessionPagSeguro = async () => {
    try {
        const { data: { sessao, script } } = await api.getSessaoPagSeguroMaxscalla();
        await loadScript(script);
        pagseguro.setSessionId(sessao);
    } catch (error) {
        alertas.erroSetSessaoPagseguro(error);
    }
};

const criarImagemBandeiraPagseguro = (caminho: string) => (
    `<img class="img-fluid" style="width: 42px;" src="https://stc.pagseguro.uol.com.br${caminho}">`
);

export const getBandeirasDeCredito = async () => {
    const { CREDIT_CARD } = await pagseguro.getMetodosPagamento(global.preco);
    return CREDIT_CARD.options;
};

export const setBandeirasAceitas = (bandeirasAceitas: {[string]: MetodoPagamento}) => {
    const htmlImagens = Object.keys(bandeirasAceitas).map((nomeBandeira) => {
        const metodo: MetodoPagamento = bandeirasAceitas[nomeBandeira];
        return criarImagemBandeiraPagseguro(metodo.images.MEDIUM.path);
    }).join('');

    $('#bandeirasCartao').html(htmlImagens);
};

export const setEventoDigitacaoNumeroCartao = (bandeirasAceitas: {[string]: MetodoPagamento}) => {
    const numeroCartao = getInputPorId('numeroCartao');

    numeroCartao.oninput = async () => {
        try {
            let band = CARTAO_UNDEFINED;
            const numeroCartaoSemMascara = `${numeroCartao.value}`.replace(/\D/g, '');
            if (numeroCartaoSemMascara.length < 6) {
                return true;
            }
            const bandeira = await pagseguro.getBandeira(numeroCartaoSemMascara);
            global.nomeBandeira = bandeira.name;
            if (bandeira.name) {
                const ban = bandeirasAceitas[bandeira.name.toUpperCase()];
                const path = get(ban, 'images.MEDIUM.path', '');
                band = `https://stc.pagseguro.uol.com.br${path}`;
            }
            $('#bandeiraCartao').attr('src', band);
            removeErrorOnInput('numeroCartao');
            return true;
        } catch (error) {
            $('#bandeiraCartao').attr('src', CARTAO_UNDEFINED);
            setErrorOnInput('numeroCartao', 'Número de cartão invalido!');
            return false;
        }
    };
};

const confirmarContratacao = applyLoading(() => import('./confirmar-contratacao').then(module => module.default()));

const setFormEvents = () => {
    btnVoltarPlano.onclick = () => mostrarPlanos();

    const form = document.forms.namedItem('formCadastroNovosEstabelecimento');
    invariant(form, 'Formulario não está no documento');
    form.onsubmit = (e) => {
        e.preventDefault();
        confirmarContratacao();
        return false;
    };
};

const setCepEvents = () => {
    const cep = document.getElementById('cep');

    if (cep) {
        cep.onkeyup = () => {
            if (cep.value.length !== 8) {
                return;
            }
            $.get('https://apps.widenet.com.br/busca-cep/api/cep.json', { code: cep.value },
                (result) => {
                    if (result.status !== 200) {
                        console.log(result.message || 'Houve um erro desconhecido');
                    }
                    $('[name="estado"]').val(result.state);
                    $('[name="cidade"]').val(result.city);
                    $('[name="bairro"]').val(result.district);
                    $('[name="endereco"]').val(result.address);
                });
        };
    }
};

const setEventos = async () => {
    mostrarPlanos();
    setAnosDeValidade();
    mascaras.mascaraCpf(document.querySelector('[name="cpf"]'));
    mascaras.mascaraCnpj(document.querySelector('[name="cnpj"]'));
    mascaras.mascaraTelefone(document.querySelector('[name="telefone"]'));
    mascaras.mascaraCartaoCredito(document.querySelector('[name="numeroCartao"]'));

    await setSessionPagSeguro();

    setFormEvents();
    setCepEvents();
};

export default setEventos;
